/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SiteEmployeeSelfUpdateDto = {
    firstName?: string;
    lastName?: string;
    phone?: string;
    title?: SiteEmployeeSelfUpdateDto.title;
    languageCode?: string;
    /**
     * Optimistic concurrency check
     */
    ocVersion?: number;
}

export namespace SiteEmployeeSelfUpdateDto {

    export enum title {
        PROF = 'PROF',
        PROF_DR = 'PROF_DR',
        DR = 'DR',
        MRS = 'MRS',
        MR = 'MR',
        MS = 'MS',
    }


}
